import React from 'react';
import classNames from 'classnames';

import css from './EmptyState.module.css';

const DefaultIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path d="M4 7h16v12H4z" />
    <path d="M4 7l2-3h12l2 3M9 11h6" />
  </svg>
);

/**
 * What a page shows when there's nothing to list: an icon, a short title, one sentence,
 * and one action. The page's own header stays above it.
 */
const EmptyState = ({ icon, title, text, action, titleAs: TitleTag = 'h2', className }) => (
  <div className={classNames(css.root, className)}>
    <span className={css.icon}>{icon || <DefaultIcon />}</span>
    <TitleTag className={css.title}>{title}</TitleTag>
    {text ? <p className={css.text}>{text}</p> : null}
    {action ? <div className={css.action}>{action}</div> : null}
  </div>
);

export default EmptyState;
